import { render, staticRenderFns } from "./CourseHeader.vue?vue&type=template&id=769d9e72&scoped=true"
import script from "./CourseHeader.vue?vue&type=script&lang=ts"
export * from "./CourseHeader.vue?vue&type=script&lang=ts"
import style0 from "./CourseHeader.vue?vue&type=style&index=0&id=769d9e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769d9e72",
  null
  
)

export default component.exports